import { api } from '@/lib/api/client';
import { publicApi } from '@/lib/api/publicClient';

/**
 * Caso 02 — event-results report client. The internal endpoint is JWT-guarded
 * via the standard axios client; the public-token endpoint uses publicAxios so
 * the share recipient never needs a session.
 */
export interface EventReportPayload {
  event: {
    id: number;
    name: string;
    address: string | null;
    startDate: string | null;
    endDate: string | null;
    eventStatus: string | null;
    companyId: number | null;
  };
  reach: {
    interactionsTotal: number;
    interactionsLast24h: number;
    distinctContacts: number;
    leadsCaptured: number;
  };
  prizes: {
    totalAllocated: number;
    totalRemaining: number;
    totalDistributed: number;
    distributedValue: number;
  };
  costs: {
    costPerInteraction: number | null;
    costPerLead: number | null;
  };
  topAnswers: Array<{
    componentId: number;
    label: string;
    type: string;
    options: Array<{ value: string; count: number; percent: number }>;
  }>;
  demographics: Record<string, Array<{ bucket: string; count: number }>>;
  timeline: Array<{ at: string; count: number }>;
  branding: {
    primaryColor: string | null;
    secondaryColor: string | null;
    logo: string | null;
    campaignName: string | null;
  } | null;
}

export interface ReportShareResponse {
  token: string;
  expiresAt: string;
  url: string;
}

export const eventReportApi = {
  internal: (eventId: number) =>
    api.get<EventReportPayload>(`/xk-event/${eventId}/report`),
  createShare: (eventId: number) =>
    api.post<ReportShareResponse>(`/xk-event/${eventId}/report/share`),
  revokeShare: (eventId: number) =>
    api.delete<{ ok: true }>(`/xk-event/${eventId}/report/share`),
  publicByToken: (token: string) =>
    publicApi.get<EventReportPayload>(`/public/event-report/${token}`),
};
